import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Clock, Download, Mail } from 'lucide-react';
import { useApp } from '../store/useApp';
import { supabase } from '../lib/supabase';

// Banner del trial: siempre visible; más prominente desde el día 5; y pantalla de solo-lectura al expirar.
// El contador NO muestra un límite ("558/3000") sino el PLAN RECOMENDADO en vivo (plan_recomendado).
export function TrialBanner() {
  const { t } = useTranslation();
  const { suscripcion, tenantActivo } = useApp();
  const tid = tenantActivo?.tenant_id;
  const [rec, setRec] = useState(null);

  useEffect(() => {
    if (!tid) return;
    supabase.rpc('plan_recomendado', { p_tenant: tid }).then(({ data }) => setRec(data || null));
  }, [tid, suscripcion?.ubicaciones_usadas]);

  if (!suscripcion || suscripcion.plan !== 'trial') return null;

  const dias = suscripcion.dias_restantes ?? 0;
  const soloLectura = suscripcion.solo_lectura || !suscripcion.activo;
  const contacto = 'mailto:hola@getagentik.co?subject=HUECO%20trial';

  if (soloLectura) {
    return (
      <div className="banner-trial expirado" data-testid="trial-expirado">
        <strong>{t('trial.expirado_titulo')}</strong>
        <span>{t('trial.expirado_texto')}</span>
        <div className="row" style={{ gap: 8 }}>
          <a className="btn primary sm" href={contacto} data-testid="trial-contacto"><Mail size={14} /> {t('trial.contacto')}</a>
          <button className="btn ghost sm" onClick={() => { window.location.href = '/ajustes'; }} data-testid="trial-descarga"><Download size={14} /> {t('ajustes.descargar')}</button>
        </div>
      </div>
    );
  }

  const urge = dias <= 2;
  // Mensaje del RPC ("558 huecos · tu tamaño encaja en NAVE, 119 €/mes"); fallback al uso si aún no llegó.
  const mensajePlan = rec?.mensaje
    || (suscripcion.ubicaciones_usadas != null ? t('trial.uso', { usadas: suscripcion.ubicaciones_usadas, limite: suscripcion.limite_ubicaciones ?? 0 }) : '');

  return (
    <div className={`banner-trial ${urge ? 'urge' : ''}`} data-testid="trial-banner">
      <span><Clock size={14} /> {t('trial.quedan', { n: dias })}</span>
      <span className="muted small" data-testid="trial-uso">{mensajePlan}</span>
      {urge && <a className="btn primary sm" href="/ajustes" data-testid="trial-hablar">{t('trial.hablar')}</a>}
    </div>
  );
}
